module.exports = __webpack_public_path__ + "img/error.cc0c35a2.png";